import { createMerkzettelStarIcon } from "@modules/merkzettel/merkzettel"
import "./advert-card-styles"
import { advertCardsContainerElement } from "@modules/azm/dom"

const clusterCallback = async (event: Event) => {
    const btn = event.target

    if (!(btn instanceof HTMLElement)) {
        return
    }
    if (!btn.hasAttribute("data-link")) {
        return
    }

    const clusterLink = btn.getAttribute("data-link")
    if (!clusterLink) {
        return
    }

    const targetModal = $(btn.getAttribute("data-target"))
    const modalContent = targetModal.find(".modal-content-inner")
    const modalTitle = targetModal.find(".modal-title")

    btn.setAttribute("loading", "")
    const response = await fetch(clusterLink).then((res) => res.text())
    btn.removeAttribute("loading")

    modalContent.html(response)
    modalTitle.html(btn.getAttribute("data-location-name") || "")

    targetModal.modal("show")

    document.documentElement.style.overflow = "hidden"

    targetModal.on("hidden.bs.modal", () => {
        document.documentElement.style.overflow = "auto"
    })
}

export function getAdvertCardMerkzettelId(card: Element) {
    return card.getAttribute("data-favourite-advert-id")
}

export function addMerkzettelIconToAdvertCard(card: Element | null) {
    card?.querySelector(".card-city")?.appendChild(createMerkzettelStarIcon())
}

advertCardsContainerElement()?.addEventListener("click", clusterCallback)
